import React, { useContext, useState } from "react";

import { Stack, Menu, MenuItem, Divider, Typography } from "@mui/material";

import { styled, alpha } from "@mui/material/styles";

//  icon
import { FaFileCsv } from "react-icons/fa6";
import { MdAddToPhotos } from "react-icons/md";
import { RiStickyNoteAddFill } from "react-icons/ri";
import { MdDelete } from "react-icons/md";

// src
import "../../Style/actionStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import StudentForm from "./StudentForm/StudentForm";
import ImportStudentDialog from "./ImportStudentDialog";
import ExportStudentCSV from "./ExportStudentCSV";
import GenerateNewClassAttended from "./GenerateNewClassAttended";
import DeleteStudentData from "./DeleteStudentData"

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function StudentBtnMenu({
  open,
  handleClose,
  anchorEl,
  setRefetch,
  userLogin,
  academicYearVal
}) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  // open create
  const [openCreate, setOpenCreate] = useState(false);
  const handleOpenCreate = () => setOpenCreate(true);
  const handleCloseCreate = () => setOpenCreate(false);

  // open import
  const [openImport, setOpenImport] = useState(false);
  const handleOpenImport = () => setOpenImport(true);
  const handleCloseImport = () => setOpenImport(false);

  // open import
  const [openGenerate, setOpenGenerate] = useState(false);
  const handleOpenGenerate = () => setOpenGenerate(true);
  const handleCloseGenerate = () => setOpenGenerate(false);

  const [openDelStu, setOpenDelStu] = useState(false)
  const handleOpenDelStu = () => setOpenDelStu(true)
  const handleCloseDelStu = () => setOpenDelStu(false)

  return (
    <div>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleOpenCreate();
            handleClose();
          }}
          disableRipple
          className="student-menu-item"
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <MdAddToPhotos className="icon" />
            <Typography
              className={language === "en" ? "action-txt" : "action-txt-kh"}
            >
              {t("btn-create")}
            </Typography>
          </Stack>
        </MenuItem>
        {
          userLogin?.role === "Admin" ? (
            <MenuItem
              onClick={() => {
                handleOpenGenerate();
                handleClose();
              }}
              disableRipple
              className="student-menu-item"
            >
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="center"
              >
                <RiStickyNoteAddFill className="icon" />
                <Typography
                  className={language === "en" ? "action-txt" : "action-txt-kh"}
                >
                  {t("generate_new_class")}
                </Typography>
              </Stack>
            </MenuItem>
          ) : ""
        }

        <Divider sx={{ my: 0.5 }} />
        <MenuItem
          // onClick={handleClose}
          disableRipple
          className="student-menu-item"
        >
          {/* <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <FaFileCsv className="icon-csv" />
            <Typography
              className={language === "en" ? "action-txt" : "action-txt-kh"}
            >
              {t("export")}
            </Typography>
          </Stack> */}
          <ExportStudentCSV academicYearVal={academicYearVal}/>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleOpenImport();
            handleClose();
          }}
          disableRipple
          className="student-menu-item"
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <FaFileCsv className="icon-csv" />
            <Typography
              className={language === "en" ? "action-txt" : "action-txt-kh"}
            >
              {t("import")}
            </Typography>
          </Stack>
        </MenuItem>

        {
          userLogin?.role === "Admin" ? (
            <>
              <Divider sx={{ my: 0.5 }} />
              <MenuItem
                onClick={() => {
                  handleOpenDelStu();
                  handleClose();
                }}
                disableRipple
                className="student-menu-item"
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="center"
                >
                  <MdDelete className="icon" />
                  <Typography
                    className={language === "en" ? "action-txt" : "action-txt-kh"}
                  >
                    {t("delete_stu")}
                  </Typography>
                </Stack>
              </MenuItem>
            </>
          ) : ""
        }

      </StyledMenu>

      {openCreate && (
        <StudentForm
          open={openCreate}
          handleClose={handleCloseCreate}
          dialogTitle="Create"
          setRefetch={setRefetch}
        />
      )}
      {openImport && (
        <ImportStudentDialog
          open={openImport}
          handleClose={handleCloseImport}
          setRefetch={setRefetch}
        />
      )}
      {openGenerate && (
        <GenerateNewClassAttended
          open={openGenerate}
          handleClose={handleCloseGenerate}
          setRefetch={setRefetch}
        />
      )}
      {openDelStu && (
        <DeleteStudentData
          open={openDelStu}
          handleClose={handleCloseDelStu}
          setRefetch={setRefetch}
        />
      )}
    </div>
  );
}
